module.exports = __webpack_public_path__ + "70fd51df6947aad1305bb5c9af6ede29.pdf";